import { round2Decimals } from "../Components/Items";

// Cada proyecto de una poliza cuadra por separado: es la misma invariante que ya asume el
// "Desglose por Proyecto" del PDF (src/Pdf/polizaPdf.js), donde la columna Diferencia tiene
// que dar cero en cada renglon.
//
// Gemelo de erp_backend/Utils/polizas.utils.js -> cuadrePorProyecto. Los dos trabajan sobre
// los valores del formulario ({cargo: Number, abono: Number, proyectoId}), asi que el
// formulario y el endpoint calculan exactamente lo mismo.
export const cuadrePorProyecto = (cargosAbonos, proyectoIdEncabezado) => {
  const grupos = new Map();

  if (!Array.isArray(cargosAbonos)) return [];

  for (const valueCA of cargosAbonos) {
    if (!valueCA) continue;

    const proyectoId = `${valueCA.proyectoId || proyectoIdEncabezado || ""}`;
    const grupo = grupos.get(proyectoId) || { proyectoId, cargos: 0, abonos: 0 };

    if (valueCA.cargo) {
      grupo.cargos = round2Decimals(grupo.cargos + valueCA.cargo);
    }
    if (valueCA.abono) {
      grupo.abonos = round2Decimals(grupo.abonos + valueCA.abono);
    }

    grupos.set(proyectoId, grupo);
  }

  return [...grupos.values()].map((grupo) => ({
    ...grupo,
    diferencia: round2Decimals(grupo.cargos - grupo.abonos),
  }));
};

// Renglones descuadrados, ya listos para el mensaje de error. Se limita a 3 proyectos porque
// message.error de antd no hace scroll y una poliza de nomina puede traer decenas.
export const mensajeDescuadrePorProyecto = (grupos, nombrePorProyectoId) => {
  const descuadrados = grupos.filter((grupo) => grupo.diferencia !== 0);

  if (descuadrados.length === 0) return null;

  const detalle = descuadrados
    .slice(0, 3)
    .map(
      (grupo) =>
        `${nombrePorProyectoId(grupo.proyectoId)} (${grupo.diferencia > 0 ? "+" : ""}${grupo.diferencia})`
    )
    .join(", ");

  const restantes = descuadrados.length - 3;

  return (
    "Cada proyecto debe cuadrar por separado. Descuadrados: " +
    detalle +
    (restantes > 0 ? ` y ${restantes} mas` : "")
  );
};

export default cuadrePorProyecto;
